import React from 'react';
import { SlideFrame } from './SlideFrame';
const acts = ['Set the scene', 'Create the conversation', 'Turn ideas into action'];
export function FinaleSlide() {
  return <SlideFrame topBand eyebrow="Finale" data-id="element-138" data-mp="jdafqmchjcuc">
      <div className="flex min-h-0 flex-1 flex-col items-center text-center" data-id="element-139" data-mp="jebt4xgz4bf8">
        <h1 className="max-w-[15ch] font-display text-[clamp(46px,6.1vw,100px)] font-bold leading-[0.96] tracking-[-0.03em]" data-id="element-140" data-mp="ocwsyvsbct35">
          Let’s start with the first question.
        </h1>

        <div className="mt-[1.8vh] max-w-[62ch] font-sans text-[clamp(12px,1vw,18px)] leading-[1.45] text-black/55" data-id="element-141" data-mp="3rsu4b827o732">
          <p data-id="element-142" data-mp="mixswefme4c">We don’t need to start with everything.</p>
          <p data-id="element-143" data-mp="ky418zxyz7j">We suggest starting with one strategic clinical question, one core audience and one connected ECCO story.</p>
        </div>

        <div className="mt-[2.7vh] flex items-center justify-center gap-[1.3vw] border-y border-black/15 px-[2vw] py-[1.3vh]" data-id="element-144" data-mp="34417789urt6v">
          {acts.map((act, index) => <React.Fragment key={act} data-id="element-145" data-mp="3909gi51dcs64" data-mpi={index}>
              <span className="font-display text-[clamp(16px,1.5vw,27px)] font-semibold text-black/70" data-id="element-146" data-mp="pv0br2xos3j3">{act}</span>
              {index < acts.length - 1 ? <span className="text-[#D62B22]" data-id="element-147" data-mp="kxqp1v1om5yy">→</span> : null}
            </React.Fragment>)}
        </div>

        <p className="mt-[1.2vh] font-sans text-[clamp(10px,0.8vw,15px)] font-semibold tracking-[0.14em] text-[#D62B22]" data-id="element-148" data-mp="g2kvqb5y9p0u">
          An encore worth sharing
        </p>

        <div className="mt-auto" data-id="element-149" data-mp="75txbs3xdy33">
          <p className="font-display text-[clamp(32px,3.8vw,65px)] font-semibold leading-none" data-id="element-150" data-mp="2560gpt0mn0y">All you need is love.</p>
          <p className="mt-[0.7vh] font-display text-[clamp(20px,2vw,35px)] font-medium text-[#D62B22]" data-id="element-151" data-mp="3taxnvhferlk2">And love grows over time.</p>
          <p className="mt-[0.7vh] font-sans text-[clamp(11px,0.9vw,17px)] text-black/45" data-id="element-152" data-mp="3odnxnzk735v6">Before we meet. While we are together. And in what we carry forward.</p>
        </div>

        <div className="mt-[2vh] bg-[#0A0A0A] px-[2.2vw] py-[1.15vh] font-display text-[clamp(15px,1.4vw,25px)] font-semibold tracking-[0.03em] text-[#F4F1E8]" data-id="element-153" data-mp="1mkrhjybfhd47">
          Define the ECCO starter
        </div>
        <p className="mt-[0.8vh] font-sans text-[clamp(9px,0.72vw,13px)] font-semibold tracking-[0.14em] text-black/35" data-id="element-154" data-mp="3lszqgbai40x7">
          The opening scene starts now.
        </p>
      </div>
    </SlideFrame>;
}